export default {
    amenities: 'Amenities',
    notEnabled: 'Amenity booking is not enabled for this account. Contact your property manager to enable it.',
    myBookings: 'My Bookings',
    bookAmenity: 'Book',
    upTo: (n: number): string => `Up to ${n} people`,
    slotLength: (m: number): string => `${m}-min slots`,
    pickDay: 'Day',
    seats: 'Seats',
    confirmBooking: 'Confirm booking',
    heldFor: 'Held for',
    slotFull: 'Full',
    slotClosed: 'Closed',
    slotPast: 'Past',
    seatsLeft: (n: number): string => `${n} left`,
    booked: 'Booking confirmed',
    bookedDesc: 'You can see and manage it under My Bookings.',
    viewMyBookings: 'View My Bookings',
    bookAnother: 'Book another slot',
    upcoming: 'Upcoming',
    past: 'Past & cancelled',
    cancelBooking: 'Cancel booking',
    cancelConfirm: 'Cancel this booking?',
    // B5: prefixed onto cancelConfirm above when B3's charge preview shows a non-zero cancellation
    // charge. charge/refund arrive already formatted (helpers.ts's cancelChargeLine applies
    // currency + cents->dollars); pct is the raw integer percentage from the matched policy tier.
    cancelChargeAndRefund: (charge: string, pct: number, refund: string): string =>
        `You'll be charged ${charge} (${pct}%). Refund ${refund}.`,
    // B5: tooltip on the disabled Cancel button once B3's `cancellable` flag says cancelling is
    // refused right now (past the policy's no-cancel deadline, or already cancelled) — the deadline
    // itself is never recomputed client-side, this just explains the disabled state.
    cancelNotAllowed: 'This booking can no longer be cancelled.',
    noAmenities: 'No amenities are available to book right now.',
    noBookings: 'You have no bookings yet.',
    browseAmenities: 'Browse amenities',
    noSlots: 'No time slots available for this day.',
    loadFailed: 'Could not load right now. Please try again.',
    notFound: 'Amenity not found.',
    backToList: 'Back to amenities',
    // §3.8 waitlist (free-mode) — join, from a full slot on the Book page.
    joinWaitlist: 'Join waitlist',
    waitlistExplain: "If a spot opens, you're confirmed automatically — no payment now.",
    waitlisted: "You're in line",
    waitlistedDesc: "We'll confirm you automatically if a spot opens. You can see and manage it under My Bookings.",
    pickAnotherSlot: 'Pick another slot',
    // §3.8 waitlist — leave, from My Bookings.
    leaveWaitlist: 'Leave waitlist',
    leaveWaitlistConfirm: 'Leave the waitlist for this slot?',
    waitlistedTag: 'Waitlisted',
    waitlistPromotedNotice: 'This became a confirmed booking.',
    // §3.7 guest passes — row action + modal, from My Bookings.
    guestPasses: 'Guest passes',
    addGuestPass: 'Add guest pass',
    noGuestPasses: 'No guest passes yet.',
    guestPassPin: 'PIN',
    guestPassRevokedTag: 'Revoked',
    // Labels the guest-pass access window (booking window + grace period, so wider than the slot).
    guestPassValid: (window: string): string => `Valid ${window}`,
    revokeGuestPass: 'Revoke',
    revokeGuestPassConfirm: 'Revoke this guest pass? The guest is emailed only if an email is on file.',
    // §3.9 SMS notification preferences — small card at the top of My Bookings.
    smsPrefsTitle: 'Text notifications',
    smsOptInLabel: 'Text me time-critical updates about my bookings',
};
